<template>
  <div>
    <div class="weixin-chat-container">
      <div class="store-info-box">
        <div class="store-info flex">
          <div v-if="loadInfo" class="store-cover-box">
            <van-icon size="24" name="shop-o" />
          </div>
          <van-image
            v-else
            class="van-front-wrap"
            width="28vw"
            height="76"
            radius="5"
            :src="storeInfo.data.shop_img"
            fit="cover"
          >
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
          <van-skeleton class="skeleton-box" title :row="2" :loading="loadInfo">
            <div class="store-text flex">
              <div class="store-name">{{ storeInfo.data.shop_name }}</div>
              <div class="work-time-box flex">
                <div class="work-time">
                  <p class="time-label">营业时间</p>
                  <p class="time-text">{{ storeInfo.data.bus_hours }}</p>
                </div>
              </div>
            </div>
          </van-skeleton>
        </div>
        <div class="store-activity flex">
          <div class="activity-label">活动内容：</div>
          <div class="activity-text">{{ storeInfo.data.activity }}</div>
        </div>
      </div>
      <div class="store-goods-box" ref="goodsListBox" :class="curTabClass">
        <ul class="store-nav-container flex" :class="navWrapClass">
          <li
            class="store-nav-item"
            v-for="(tab, index) in tabs"
            @click="toggle(index)"
            :class="{ active: active == index }"
            :key="index"
          >
            {{ tab.type }}
          </li>
        </ul>
        <div class="store-infomation-wrap">
          <div v-if="active == 0" class="goods-container">
            <div
              class="load-goods-box"
              v-show="loadGoodsList"
              :style="loadingBoxStyle"
            >
              <van-loading size="24px">加载中...</van-loading>
            </div>
            <div
              class="without-fetch-content"
              v-if="goodsList.length == 0 && loadingFinished"
            >
              <img src="../assets/image/cl_without_goods.png" />
              <span>商品未上架</span>
            </div>
            <div
              class="goods-item"
              v-for="(item, index) in goodsList"
              :key="index"
            >
              <van-image
                class="goods-cover-wrap"
                :src="item.uri"
                height="124"
                :width="coverWidth"
                fit="cover"
                lazy-load
              >
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
              <div class="goods-info">
                <p class="goods-name">{{ item.goods_name }}</p>
                <p class="goods-info-text">{{ item.info }}</p>
                <p class="goods-price-box">
                  <span :class="item.discount_class"
                    >￥{{ item.special_price }}</span
                  >
                  <span :class="item.origin_class">￥{{ item.price }}</span>
                </p>
              </div>
            </div>
          </div>
          <div v-else class="info-item-box">
            <div class="info-item cut-off-line">
              <div class="info-label">商家名称</div>
              <div class="info-content">{{ storeInfo.data.shop_name }}</div>
            </div>
            <div class="info-item cut-off-line">
              <div class="info-label shop-location">
                <span>商家地址</span>
              </div>
              <div class="info-content">{{ shopAddress }}</div>
            </div>
            <div class="info-item cut-off-line">
              <div class="info-label">营业时间</div>
              <div class="info-content">{{ storeInfo.data.bus_hours }}</div>
            </div>
            <div class="info-item">
              <div class="info-label">营业执照</div>
              <div>
                <van-image
                  class="van-front-wrap"
                  width="30vw"
                  :src="storeInfo.data.license"
                  fit="cover"
                >
                  <template v-slot:loading>
                    <van-loading type="spinner" size="20" />
                  </template>
                </van-image>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="company-container">
        <p class="mobile-logo">
          <img src="../assets/image/cl_mobile_logo.png" alt />
        </p>
        <p class="mobile-slogan">
          <img src="../assets/image/cl_mobile_slogan.png" alt />
        </p>
        <p class="mobile-download">
          <a id="downloadBtn" href="javascript:;">下载传联APP</a>
        </p>
        <p class="company-name">贵州传联网络科技有限公司</p>
        <p class="company-domain">www.handlian.com</p>
      </div>
    </div>
  </div>
</template>
<script>
import { apiMap } from "../utils/apiMap";
export default {
  name: "weixin-share-shop",
  data() {
    var loadWidth = `${document.documentElement.clientWidth}px`;
    var goodsCovWidth = document.documentElement.clientWidth * 0.44;
    return {
      loadInfo: true,
      active: 0,
      loadGoodsList: true,
      loadingFinished: false,
      tabs: [
        {
          type: "商品",
        },
        {
          type: "商家信息",
        },
      ],
      storeInfo: {
        data: {
          activity: "------",
          address: "",
          bus_hours: "未设置营业时间",
          id: "",
          lat: "",
          lng: "",
          license: "",
          shop_name: "",
          shop_img: "",
          state: 1,
        },
        income: "￥0.00",
      },
      goodsList: [],
      loadingBoxStyle: {
        width: loadWidth,
      },
      coverWidth: goodsCovWidth,
    };
  },
  computed: {
    curTabClass() {
      return this.active == 1 ? "white-back" : "";
    },
    navWrapClass() {
      return this.active == 0 ? "margin-box" : "";
    },
    shopAddress() {
      if (
        this.storeInfo.data.address2 != null &&
        this.storeInfo.data.address2 != "null"
      ) {
        return `${this.storeInfo.data.address}${this.storeInfo.data.address2}`;
      }
      return this.storeInfo.data.address;
    },
  },
  mounted() {
    this.getShopDetail();
    this.getShopGoods();
    this.getApk();
  },
  methods: {
    getShopDetail() {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["shopDetail"]["method"],
          url: apiMap["shopDetail"]["url"],
          params: {
            shopId: _this.$route.query.id,
          },
        })
        .then(function (response) {
          _this.loadFeed = false;
          if (response.data.result.data !== null) {
            var tempInfo = response.data.result;
            if (tempInfo.data.activity == null) {
              tempInfo.data.activity = "暂无活动";
            }
            if (tempInfo.data.bus_hours == null) {
              tempInfo.data.bus_hours = "未设置营业时间";
            }
            _this.storeInfo = tempInfo;
            _this.loadInfo = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getShopGoods() {
      let _this = this;
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["shopGoods"]["method"],
        url: apiMap["shopGoods"]["url"],
        params: {
          shopId: _this.$route.query.id,
          state: "1", //查询上架的商品
          start: 1,
          count: 10,
        },
      })
        .then(function (response) {
          _this.loadGoodsList = false;
          if (response.data.result.statusCode == 1) {
            let tempList = response.data.result.data;
            tempList.forEach((element) => {
              element.price = Number(element.price).toPrecision();
              element.special_price = Number(
                element.special_price
              ).toPrecision();
              element.discount_class =
                element.special_price > 0 ? "is-discount" : "not-discount";
              element.origin_class =
                element.special_price > 0 ? "through-line" : "not-through";
              _this.goodsList.push(element);
            });
            if (response.data.result.data.length < 1) {
              _this.loadingFinished = true;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    toggle(index) {
      this.active = index;
    },
    getApk() {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["appLink"]["method"],
          url: apiMap["appLink"]["url"],
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            var element = document.querySelector("#downloadBtn");
            element.setAttribute("href", response.data.result.data.Android.uri);
            var ua = navigator.userAgent.toLowerCase();
            console.log(ua);
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              element.addEventListener("click", function () {
                alert("请点击右上角按钮，并选择浏览器打开");
              });
              element.setAttribute("href", "javascript:;");
            } else if (ua.match(/QQ\//i) == "qq/") {
              element.setAttribute(
                "href",
                response.data.result.data.Android.uri
              );
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.weixin-chat-container {
  background-color: #f6f7f8;
}

.store-info-box {
  padding: 22px 15px 15px;
  margin-bottom: 10px;
  color: #333333;
  background-color: #ffffff;
}

.store-cover-box {
  display: flex;
  height: 90px;
  flex: 1;
  justify-content: center;
  flex-direction: column;
  line-height: 90px;
  text-align: center;
  color: #999999;
  border-radius: 8px;
  background-color: #e5f2ff;
}

.shop-icon {
  width: 38px;
  margin: 0 auto;
}

.nav-btn {
  color: #ffffff;
}

.skeleton-box {
  flex: 2;
}

.van-front-wrap {
  min-width: 100px;
}

.store-text {
  flex: 2;
  margin-left: 10px;
  flex-direction: column;
}

.store-name {
  flex: 1;
  font-size: 16px;
  font-weight: bold;
}

.work-time-box {
  flex: 2;
  justify-content: space-between;
  line-height: 25px;
}

.time-text {
  line-height: 16px;
}

.link-box {
  min-width: 70px;
}

.link-btn-box {
  display: flex;
  justify-content: space-between;
}

.work-time {
  font-size: 14px;
}

.income-label {
  color: #fb9300;
  font-size: 14px;
  text-align: right;
}

.income-text {
  color: #fb9300;
  text-align: right;
  font-weight: bold;
}

.phone-icon {
  margin-right: 15px;
}

.store-activity {
  margin-top: 10px;
  font-size: 14px;
}

.activity-label {
  flex: 1;
  font-weight: bold;
}

.activity-text {
  flex: 3;
}

.white-back {
  background-color: #ffffff;
}

.store-nav-container {
  margin: 15px 0;
  padding: 15px 15px 0;
}

.store-nav-item {
  margin-right: 45px;
}

.store-nav-item.active {
  color: #1989fa;
}

.close-down-box {
  width: 100%;
  padding: 15px;
  color: #ffffff;
  background-color: #fb9300;
}

.apply-btn-box {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.state-text {
  font-weight: bold;
}

.tip-text {
  margin-top: 10px;
  line-height: 25px;
}

/* 商品列表begin */
.load-goods-box {
  margin: 10px 0;
  text-align: center;
}

.goods-container {
  width: 100%;
  max-height: 428px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow-y: scroll;
}

.goods-item {
  width: 44%;
  margin-top: 15px;
  margin-left: 4%;
  border-radius: 8px;
  background-color: #ffffff;
}

.goods-image {
  display: flex;
  width: 100%;
  height: 90px;
  line-height: 90px;
  text-align: center;
  justify-content: center;
  flex-direction: column;
  background-color: #e5f2ff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.goods-info {
  padding: 0 12px;
  text-align: left;
  font-size: 14px;
  line-height: 24px;
}

.goods-info p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.goods-name {
  font-weight: bold;
  color: #333333;
}

.goods-info-text {
  color: #999999;
}

.not-discount {
  display: none;
}

.not-through,
.is-discount {
  font-weight: bold;
  color: #ff4242;
}

.through-line {
  margin-left: 7px;
  color: #999999;
  text-decoration: line-through;
}

.without-fetch-content {
  width: 180px;
  margin: 30px auto 0;
  line-height: 25px;
  text-align: center;
  color: #999999;
}

.without-fetch-content img {
  width: 100%;
}
/* 商品列表end */

/* 商家资料begin */
.info-item-box {
  padding: 0 15px;
}

.info-item {
  padding: 20px 0;
}

.info-label {
  margin-bottom: 10px;
  font-weight: bold;
}

.info-content {
  line-height: 30px;
}

.cut-off-line {
  border-bottom: 1px solid #f5f5f5;
}

.shop-location {
  display: flex;
  justify-content: space-between;
}
/* 商家资料end */

/* 底部宣传logo */
.company-container {
  margin-top: 18px;
  padding-top: 20px;
  text-align: center;
  background-color: #ffffff;
}

.user-avatar {
  width: 16vw;
  height: 16vw;
  object-fit: cover;
  border: 1px solid #f5f5f5;
}

.admin-avatar {
  width: 16vw;
  height: 16vw;
  object-fit: cover;
}

.user-name {
  font-size: 16px;
  font-weight: bold;
}

.header-right {
  margin-left: 10px;
  flex-direction: column;
  justify-content: space-evenly;
}

.feed-body {
  margin-top: 0.4rem;
  padding: 0.4rem;
  border: 1px solid #eeeeee;
  border-radius: 3px;
}

.mobile-logo {
  width: 25.6vw;
  height: 28vw;
  margin: 1rem auto 1rem;
}

.mobile-slogan {
  width: 59vw;
  height: 6vw;
  margin: 0 auto;
}

.mobile-logo img {
  width: 100%;
}

.mobile-slogan img {
  width: 100%;
}

.mobile-download {
  width: 58vw;
  height: 8vw;
  margin: 1rem auto 1rem;
  line-height: 8vw;
  background-color: #0071ff;
  border-radius: 4px;
}

.mobile-download a {
  display: block;
  color: #ffffff;
  font-size: 16px;
}

.company-name {
  color: #888888;
  font-size: 16px;
  line-height: 8vw;
}

.company-domain {
  margin-bottom: 1rem;
  font-size: 16px;
  color: #888888;
  line-height: 5vw;
}
/* 底部宣传end */
</style>